import React, { useState, useEffect, Fragment } from "react";
import { ReactComponent as UserIcon } from "../../assets/icons/userIcon.svg";
import { ReactComponent as PasswordIcon } from "../../assets/icons/passwordIcon.svg";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  withTheme,
  Typography,
  Button,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import { UserService, auth } from "../../services";
import { compose } from "redux";
import styles from "./styles";
import { updateCurrentUserAction, setInitialyLoaded, enableProductDropDown, enableVariantManagementTab } from "../../redux/actions";
import { domainLevelConfig } from "../../ui-config";
import classNames from "classnames";
import { getQueryStringValue, handleServerErrors } from "../../helpers";
import OtpFiller from "./OtpFiller";
import SuperAdminRouteMaster from "../SuperAdmin/routeMaster";
import CustomerAdminRouteMaster from "../CustomerAdmin/routeMaster";
import { Notification } from "../Common";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import { useSnackbar } from "notistack";
import VerifyOtpLayout from "./VerifyOtpLayout"; // Import the new component

const EmailPasswordLayout = ({
  email = "",
  password = "",
  loader = false,
  hostConfig = {},
  theme = {},
  onOtpClick = () => {},
  onEmailChange = () => {},
  onPasswordChange = () => {},
  onSubmit = () => {},
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [userFocus, setUserFocus] = useState(false);
  const [passFocus, setPassFocus] = useState(false);

  const classes = styles();
  return (
    <>
      <form
        onSubmit={onSubmit}
        style={{
          padding: "1em 2.5em 1em 2.5em ",
          fontFamily: "Ubuntu",
        }}
      >
        <Typography className={classes.label} style={{ color: userFocus && theme.palette.primary.main }}>Username / Email</Typography>
        <TextField
          placeholder="Enter your Username / Email"
          variant="outlined"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          className={classes.input}
          required
          type={"text"}
          onFocus={() => setUserFocus(true)}
          onBlur={() => setUserFocus(false)}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                style={{
                  backgroundColor: "#FAFAFA",
                  border: "1px solid #E2E2E2",
                  height: 27,
                  width: 33,
                  borderRadius: 17,
                  marginLeft: -9,
                }}
              >
                <UserIcon stroke={userFocus ? theme.palette.primary.main : ""} strokeWidth="1" className={classes.fieldIcon} />
              </InputAdornment>
            ),
          }}
        />
        <Typography className={classes.label} style={{ flex: 1, color: passFocus && theme.palette.primary.main }}>
          Password
        </Typography>
        <TextField
          placeholder="Enter your password"
          variant="outlined"
          required
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          className={classes.input}
          type={showPassword ? "text" : "password"}
          onFocus={() => setPassFocus(true)}
          onBlur={() => setPassFocus(false)}
          style={{
            marginTop: 4,
            color: hostConfig.themeColor ? hostConfig.themeColor : "#39A8E0",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                style={{
                  backgroundColor: "#FAFAFA",
                  border: "1px solid #E2E2E2",
                  height: 27,
                  width: 36,
                  borderRadius: 17,
                  marginLeft: -9,
                }}
              >
                <PasswordIcon stroke={passFocus ? theme.palette.primary.main : ""} strokeWidth="1" className={classes.fieldIcon} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment className={classNames(classes.passwordIcon, classes.visibility)} position="end" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </InputAdornment>
            )
          }}
        />
        <div style={{ textAlign: "right" }}>
          <Link
            className="login-links"
            style={{
              color: "#707070",
              textDecoration: "none",
            }}
            to="/forgot-password"
          >
            Forgot Password?
          </Link>
        </div>
        <Button
          className={classes.buttonSign}
          type="submit"
          variant="contained"
          style={{
            marginTop: "15%",
            backgroundColor: theme.palette.primary.main ? theme.palette.primary.main : "#39A8E0",
          }}
        >
          {loader ? (
            <>
              <CircularProgress
                color="#fff"
                size={16}
                style={{ marginLeft: 0 }}
              />{" "}
              Sign in
            </>
          ) : (
            "Sign In"
          )}
        </Button>
        <Button
          className={classes.buttonSign}
          variant="contained"
          style={{
            marginTop: "15px",
            backgroundColor: theme.palette.primary.main ? theme.palette.primary.main : "#39A8E0",
          }}
          onClick={onOtpClick}
        >
          Login with OTP
        </Button>
      </form>
    </>
  );
};

const EmailForOtpLayout = ({
  email = "",
  loader = false,
  hostConfig = {},
  theme = {},
  onEmailChange = () => {},
  onSendOtp = () => {},
}) => {
  const [userFocus, setUserFocus] = useState(false);
  const classes = styles();

  return (
    <>
      <form
        onSubmit={onSendOtp}
        style={{
          padding: "1em 2.5em 1em 2.5em ",
          fontFamily: "Ubuntu",
        }}
      >
        <Typography className={classes.label} style={{ color: userFocus && theme.palette.primary.main }}>Enter your Email</Typography>
        <TextField
          placeholder="Enter your Email"
          variant="outlined"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          className={classes.input}
          required
          type={"text"}
          onFocus={() => setUserFocus(true)}
          onBlur={() => setUserFocus(false)}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                style={{
                  backgroundColor: "#FAFAFA",
                  border: "1px solid #E2E2E2",
                  height: 27,
                  width: 33,
                  borderRadius: 17,
                  marginLeft: -9,
                }}
              >
                <UserIcon stroke={userFocus ? theme.palette.primary.main : ""} strokeWidth="1" className={classes.fieldIcon} />
              </InputAdornment>
            ),
          }}
        />
        <Button
          className={classes.buttonSign}
          type="submit"
          variant="contained"
          style={{
            marginTop: "15%",
            backgroundColor: theme.palette.primary.main ? theme.palette.primary.main : "#39A8E0",
          }}
        >
          {loader ? (
            <>
              <CircularProgress
                color="#fff"
                size={16}
                style={{ marginLeft: 0 }}
              />{" "}
              Send OTP
            </>
          ) : (
            "Send OTP"
          )}
        </Button>
      </form>
    </>
  );
};

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [otpLogin, setOtpLogin] = useState(false);
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const [notification, setNotification] = useState("");
  const [otp, setOtp] = useState("");
  const [otpStep, setOtpStep] = useState(false);
  const [otpVerification, setOtpVerification] = useState(false);

  const classes = styles();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    window.localStorage.clear();
    auth.remove_user();
  }, []);

  useEffect(() => {
    const handlePopState = (event) => {
      if (event.state && event.state.otp) {
        if (event.state.step === 'otpStep') {
          setOtpStep(true);
          setOtpVerification(false);
        } else if (event.state.step === 'otpVerification') {
          setOtpVerification(true);
          setOtpStep(false);
        }
      } else {
        setOtpStep(false);
        setOtpVerification(false);
      }
    };
  
    window.addEventListener('popstate', handlePopState);
  
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ ;
    return re.test(String(email).toLowerCase())||email === "";
  };

  const sendOtp = async (email) => {
    const payload = {
      email: email,
      intent: "sign_in"
    };
    try {
      const response = await window.axiosIns.post(
        "/user/send_otp",
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error sending OTP:', error);
      throw error;
    }
  };

  const verifyOtpAndLogin = async (email, otp) => {
    const payload = {
      email: email,
      otp: otp
    };
    try {
      const response = await window.axiosIns.post(
        "/otp/otp_login",
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error logging in with OTP:', error);
      throw error;
    }
  };

  const handleOtpClick = () => {
    if (validateEmail(email)) {
      setOtpStep(true);
      window.history.pushState({ otp: true, step: 'otpStep' }, ''); // Add this line
    } else {
      displayNotification("Please enter a valid email address.");
    }
  };

  const sendOtpReqest = async (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      try {
        await sendOtp(email);
        setOtpStep(false); // Disable email step
        setOtpVerification(true); // Enable OTP verification step
        setOtpLogin(true); // Enable OTP login
        window.history.pushState({ otp: true, step: 'otpVerification' }, ''); // Add this line
        displayNotification("OTP has been sent to the registered Email")
      } catch (error) {
        const errorMessage = error.response && error.response.data && error.response.data.message 
          ? error.response.data.message 
          : "Some error occured, please try again later";
        displayNotification(errorMessage);
      }
    } else {
      displayNotification("Please enter a valid email address.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loader) {
      return;
    }
    setLoader(true);
    props.setInitialyLoaded({initialyLoaded:false});
    UserService.login({ username: email, password: password }, {})
      .then((user) => {
        user.lastTokenRefresh = new Date();
        auth.set_user(user);
        props.updateCurrentUser(user);
        props.enableProductDropDown(user.enable_product_language);
        props.enableVariantManagementTab(user.enable_variant_management);
        setLoader(false);
        if (user?.type === 'EM') updateStatus()
        redirect(user);
      })
      .catch((error) => {
        navigator.onLine
          ? handleServerErrors(error, enqueueSnackbar, "Wrong username or password. Please try again.", true)
          : displayNotification("Please check your internet connection.");
        setLoader(false);
      });
  };

  const loginWithOtp = (e) => {
    e.preventDefault();
    UserService.otpLogin({ otp })
      .then((user) => {
        user.lastTokenRefresh = new Date();
        auth.set_user(user);
        props.updateCurrentUser(user);
        setLoader(false);
        if (user?.type === 'EM') updateStatus()
        redirect(user);
      })
      .catch((error) => {
        try {
          displayNotification(error.response.data.message);
        } catch (error) {
          displayNotification("Could not Login with OTP, Please try again");
        }
      });
  };

  const userLoginWithOtp = async (e) => {
    e.preventDefault();
    UserService.otpLogin({ otp })
      .then((user) => {
        user.lastTokenRefresh = new Date();
        auth.set_user(user);
        props.updateCurrentUser(user);
        setLoader(false);
        if (user?.type === 'EM') updateStatus()
        redirect(user);
      })
      .catch((error) => {
        try {
          displayNotification(error.response.data.message);
        } catch (error) {
          displayNotification("Could not Login with OTP, Please try again");
        }
      });
  };

  const updateStatus = async () => {
    const callData = {
      is_taking_calls: true,
    };
    await window.axiosIns.post("/call_request/is_available", callData);
  };

  const redirect = (user) => {
    let next = getQueryStringValue("next");
    if (next && next !== "/") {
      const routes = ["SA", "DA", "EU", "DE", "FO", "GA", "EM"].includes(user.type)
        ? SuperAdminRouteMaster
        : user.type === "CA"
        ? CustomerAdminRouteMaster
        : [];

      const matched_route = routes.find((x) => x.path === next);
      next = !!matched_route ? next : "/";
      if (next !== "/" && user.type === "DA" && matched_route.onlySA) {
        next = "/";
      }
      props.history.push(next);
    } else {
      props.history.push("/");
    }
  };

  const displayNotification = (message) => {
    setNotification(message);
    setTimeout(() => {
      setNotification("");
    }, 3000);
  };

  const hostConfig = domainLevelConfig[props.host] || domainLevelConfig["default"] || {};

  return (
    <Fragment>
      <div
        className={`${classes.container}`}
        style={{ backgroundImage: `url(${hostConfig.coverImage})` }}
      >
        <Notification
          style={{ position: "absolute", top: '-30px', left: '40%' }}
          visible={!!notification}
          message={notification}
        />
        <div className={classes.formContainer}>
          <div className={classes.formLogo}>
            <div
              style={{
                height: 74,
                width: 200,
                display: "flex",
                alignItems: "center",
                paddingTop: 3,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  backgroundImage: `url(${props.appLogo
                    ? props.appLogo
                    : hostConfig.logo || props.currentUser.company.logo || hostConfig.navLogo})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  height: "100%",
                  width: "100%",
                }}
              ></div>
            </div>
          </div>
          <Typography
            className={classes.loginTitle}
            style={{
              backgroundColor: props.theme.palette.primary.main
            }}
          >
            {hostConfig?.navTitle ?? "VENDING TRACKER"}
          </Typography>
          {otpVerification ? (
            <VerifyOtpLayout
              otp={otp}
              onOtpChange={(value) => setOtp(value)}
              onVerifyOtp={userLoginWithOtp}
              onResendOtp={sendOtpReqest}
              hostConfig={hostConfig}
              theme={props.theme}
              loader={loader}
              onBack={() => {
                setOtpVerification(false);
                setOtpStep(true);
                window.history.back(); // Navigate back in history
              }}
            />
          ) : (
            otpStep ? (
              <EmailForOtpLayout
                email={email}
                onEmailChange={(mail) => setEmail(mail)}
                onSendOtp={sendOtpReqest}
                hostConfig={hostConfig}
                theme={props.theme}
                loader={loader}
              />
            ) : (
              <EmailPasswordLayout
                email={email}
                password={password}
                onEmailChange={(mail) => setEmail(mail)}
                onPasswordChange={(pass) => setPassword(pass)}
                onOtpClick={handleOtpClick}
                hostConfig={hostConfig}
                theme={props.theme}
                loader={loader}
                onSubmit={handleSubmit}
              />
            )
          )}
        </div>
        <Grid item md={12} style={{ backgroundColor: "#ffffffdb", position: 'absolute', bottom: '0', width: '100vw' }}>
          <Grid container style={{ padding: "10px 0" }}>
            <Grid item xs={12} md={9} className={classes.footer}>
              {hostConfig.aboutURL ? (
                <a href={hostConfig.aboutURL}
                  className="login-links"
                  style={{
                    color: props.theme.palette.primary.main,
                    marginLeft: "3em",
                    fontWeight: 700,
                  }}
                  rel="noopener noreferrer" target="_blank">
                  About
                </a>
              ) : (
                <Link
                  className="login-links"
                  style={{
                    color: props.theme.palette.primary.main,
                    marginLeft: "3em",
                    fontWeight: 700,
                  }}
                  to="/about"
                >
                  About
                </Link>
              )}
              {hostConfig.helpCenterURL ? (
                <a href={hostConfig.helpCenterURL}
                  className="login-links"
                  style={{
                    color: props.theme.palette.primary.main,
                    marginLeft: "3em",
                    fontWeight: 700,
                  }} rel="noopener noreferrer" target="_blank">
                  Help Center
                </a>
              ) : null}
              {hostConfig.termsServiceURL ? (
                <a href={hostConfig.termsServiceURL}
                  className="login-links"
                  style={{
                    color: props.theme.palette.primary.main,
                    marginLeft: "3em",
                    fontWeight: 700,
                  }}
                  rel="noopener noreferrer" target="_blank">
                  Terms of Service
                </a>
              ) : (
                <Link
                  className="login-links"
                  style={{
                    color: props.theme.palette.primary.main,
                    marginLeft: "3em",
                    fontWeight: 700,
                  }}
                  to="/term"
                >
                  Terms of Service
                </Link>
              )}
              {hostConfig.privacyPolicyURL ? (
                <a href={hostConfig.privacyPolicyURL}
                  className="login-links"
                  style={{
                    color: props.theme.palette.primary.main,
                    marginLeft: "3em",
                    fontWeight: 700,
                  }}
                  rel="noopener noreferrer" target="_blank">
                  Privacy Policy
                </a>
              ) : (
                <Link
                  className="login-links"
                  style={{
                    color: props.theme.palette.primary.main,
                    marginLeft: "3em",
                    fontWeight: 700,
                  }}
                  to="/policy"
                >
                  Privacy Policy
                </Link>
              )}
            </Grid>
            <Grid item xs={12} md={3} className={classes.copyright} style={{ color: props.theme.palette.primary.main, textAlign: 'right', paddingRight: '40px' }}>
              © {new Date().getFullYear()} {hostConfig.name}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );

};

const mapStateToProps = (state) => {
  return {
    host: state.userReducer.host,
    theme: state.userReducer.theme,
    customTheme: state.userReducer.customTheme,
    appLogo: state.userReducer.appLogo
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
    enableProductDropDown: (data) => dispatch(enableProductDropDown(data)),
    enableVariantManagementTab: (data) => dispatch(enableVariantManagementTab(data)),
    setInitialyLoaded: (data) => dispatch(setInitialyLoaded(data)),
  };
};

export default compose(
  withTheme,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Login);
